import React, { useState } from "react";
import { Card, Tab, Nav } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import { useLocation } from "react-router-dom";
import UsersTableInternal from "./UsersTableInternal";

export default function UserListInternal() {
  const location = useLocation();

  return (
    <div>
      <PageTitle activeMenu="Users List" motherMenu="User Management" />
      <Card>
        <Card.Body>
          <div className="default-tab">
            <UsersTableInternal />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
